/*
 * @Description: 0：拥有者 1：管理员 2：可编辑 3：查看 4：删除
 */

const checkPermission = (hasPerm, el) => {
  el.style.display = hasPerm ? el._originalDisplay : 'none'
}

// 查看
const shareHidden = {
  mounted(el, binding) {
    const hasPerm = binding.value <= 2
    el._originalDisplay = el.style.display || getComputedStyle(el).display
    checkPermission(hasPerm, el)
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      const hasPerm = binding.value <= 2
      checkPermission(hasPerm, el)
    }
  }
}

// 修改项目信息
const shareEditProject = {
  mounted(el, binding) {
    const hasPerm = binding.value <= 2
    el._originalDisplay = el.style.display || getComputedStyle(el).display
    checkPermission(hasPerm, el)
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      const hasPerm = binding.value <= 2
      checkPermission(hasPerm, el)
    }
  }
}

// 暂停爬取
const shareCrawler = {
  mounted(el, binding) {
    const hasPerm = binding.value <= 1
    el._originalDisplay = el.style.display || getComputedStyle(el).display
    checkPermission(hasPerm, el)
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      const hasPerm = binding.value <= 1
      checkPermission(hasPerm, el)
    }
  }
}

// 品牌设置
const shareBrandSet = {
  mounted(el, binding) {
    const hasPerm = binding.value <= 2
    el._originalDisplay = el.style.display || getComputedStyle(el).display
    checkPermission(hasPerm, el)
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      const hasPerm = binding.value <= 2
      checkPermission(hasPerm, el)
    }
  }
}

// BI数据下载
const shareBIDownload = {
  mounted(el, binding) {
    const hasPerm = binding.value <= 2
    el._originalDisplay = el.style.display || getComputedStyle(el).display
    checkPermission(hasPerm, el)
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      const hasPerm = binding.value <= 2
      checkPermission(hasPerm, el)
    }
  }
}

// 原始数据下载
const shareCrawlerDownload = {
  mounted(el, binding) {
    const hasPerm = binding.value <= 2
    el._originalDisplay = el.style.display || getComputedStyle(el).display
    checkPermission(hasPerm, el)
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      const hasPerm = binding.value <= 2
      checkPermission(hasPerm, el)
    }
  }
}

// 分享项目链接
const shareShareLink = {
  mounted(el, binding) {
    const hasPerm = binding.value <= 2
    el._originalDisplay = el.style.display || getComputedStyle(el).display
    checkPermission(hasPerm, el)
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      const hasPerm = binding.value <= 2
      checkPermission(hasPerm, el)
    }
  }
}

// 修改项目成员权限
const shareShareRole = {
  mounted(el, binding) {
    const hasPerm = binding.value <= 1
    el._originalDisplay = el.style.display || getComputedStyle(el).display
    checkPermission(hasPerm, el)
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      const hasPerm = binding.value <= 1
      checkPermission(hasPerm, el)
    }
  }
}

export default {
  install(app) {
    app.directive('share-hidden', shareHidden)
    app.directive('share-edit-project', shareEditProject)
    app.directive('share-crawler', shareCrawler)
    app.directive('share-brand-set', shareBrandSet)
    app.directive('share-bi-download', shareBIDownload)
    app.directive('share-crawler-download', shareCrawlerDownload)
    app.directive('share-share-link', shareShareLink)
    app.directive('share-share-role', shareShareRole)
  }
}
